module.exports = __webpack_public_path__ + "img/เครื่องบดอาหาร.03ce4ba8.png";